<div role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true">
  <div class="float-left bg-white card-background">

<iframe  #uwIframe [src]="urlforHOUnderwriting | safe" (load)="onLoadFunc(uwIframe)"  width="100%"       
class="borderHide" height="700" id="IFrame">
</iframe>


</div>
</div>